import styled, { keyframes } from "styled-components"

const SpinnerAnim = keyframes`
    0%, 20%, 80%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.5);
    }
`

export const SpinnerPoint = styled.div<{
    size: number
    top: number
    left: number
    color?: string
    animLength: number
    animDelay: number
}>`
    position: absolute;
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    top: ${(props) => props.top}px;
    left: ${(props) => props.left}px;
    background: ${(props) => props.color || props.theme.spinnerColor};
    border-radius: 50%;
    animation: ${SpinnerAnim} ${(props) => props.animLength}s linear infinite;
    animation-delay: ${(props) => props.animDelay}s;
`

export const SpinnerWrapper = styled.div<{ size: number }>`
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    position: relative;
`
